import { CaseSortColumnType, fetchCases, clearCases } from '../../store/case';

import { ApplicationState } from '../../store';
import { CaseSearch } from '../../store/case/model';
import React from 'react';
import { connect } from 'react-redux';
import styles from './case-details-header.module.css';
import { Role } from '../../store/shared/model';
import { SortColumnDirectionType } from '../../store/shared/types';
import { Dispatch } from 'redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';

interface PropsFromState {
  readonly roles: string[];
  readonly sortColumn: CaseSortColumnType;
  readonly sortDirection: SortColumnDirectionType;
  readonly caseSearch: CaseSearch;
}

interface PropsFromDispatch {
  readonly clearCases: typeof clearCases;
  readonly fetchCases: typeof fetchCases;
}

type AllProps = PropsFromDispatch & PropsFromState;

class CaseDetailsHeader extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  renderSortIcon = (sortColumnName: CaseSortColumnType, isFirst: boolean) => {
    const style: any = { marginLeft: '0px', visibility: 'visible' };
    const displayIcon = this.props.sortColumn === sortColumnName;
    const isUpIcon = this.props.sortDirection === 'DESC';

    if (isFirst) { style.marginLeft = '195px'; }
    if (!displayIcon) { style.visibility = 'hidden'; }

    if (!isUpIcon) { return <img alt="" src={require('../../assets/images/arrow_up.png')} style={style} />; }
    return <img alt="" src={require('../../assets/images/arrow_down.png')} style={style} />;
  }

  setSortValues = (column: CaseSortColumnType) => {
    const newCaseSearch = { ...this.props.caseSearch };
    if (newCaseSearch.sortColumn === column) {
      // should change sort direction
      newCaseSearch.sortDirection = newCaseSearch.sortDirection === 'ASC' ? 'DESC' : 'ASC';
    } else {
      // ascending by default
      newCaseSearch.sortDirection = 'ASC';
    }

    newCaseSearch.sortColumn = column;
    this.props.clearCases();
    this.props.fetchCases({ ...this.props.caseSearch, sortColumn: column, sortDirection: newCaseSearch.sortDirection }, 0, false);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.firstColumnWrapper} onClick={() => this.setSortValues('CASE_CODE')}>
          <div className={styles.damageType}>
            <img alt="" src={require('../../assets/images/explosion_75x75.png')} />
          </div>
          <div className={`${styles.text} ${styles.caseCode}`}>
            {this.renderSortIcon('CASE_CODE', true)}
          </div>
        </div>
        <div className={`${styles.text} ${styles.insuredPersonName}`} onClick={() => this.setSortValues('INSURED_PERSON_NAME')}>
          <span>{this.localization.get('home.column.name')}</span>
          {this.renderSortIcon('INSURED_PERSON_NAME', false)}
        </div>
        <div className={`${styles.text} ${styles.insuredPersonData}`} onClick={() => this.setSortValues('ADDRESS')}>
          <span>{this.localization.get('home.column.address')}</span>
          {this.renderSortIcon('ADDRESS', false)}
        </div>
        <div className={`${styles.text} ${styles.zipCode}`} onClick={() => this.setSortValues('ZIP_CODE')}>
          <span>{this.localization.get('home.column.postalcode')}</span>
          {this.renderSortIcon('ZIP_CODE', false)}
        </div>
        <div className={`${styles.text} ${styles.receivedDate}`} onClick={() => this.setSortValues('RECEIVED_DATE')}>
          <span>{this.localization.get('home.column.received')}</span>
          {this.renderSortIcon('RECEIVED_DATE', false)}
        </div>
        <div className={`${styles.text} ${styles.visitDate}`} onClick={() => this.setSortValues('VISIT_DATE')}>
          <span>{this.localization.get('home.column.appointment')}</span>
          {this.renderSortIcon('VISIT_DATE', false)}
        </div>
        <div className={`${styles.text} ${styles.agendaReference}`} onClick={() => this.setSortValues('AGENDA_REF')}>
          <span>{this.localization.get('home.column.agendaRef')}</span>
          {this.renderSortIcon('AGENDA_REF', false)}
        </div>
        {this.props.roles.includes(Role.AsUs) || ((this.props.roles.includes(Role.CoCaEx) || this.props.roles.includes(Role.CoCaIn)) && this.props.caseSearch.selectedPartyId > 0) ?
          <div className={`${styles.text} ${styles.expertName}`} onClick={() => this.setSortValues('EXPERT_NAME')}>
            <span>{this.localization.get('home.column.assignedTo')}</span>
            {this.renderSortIcon('EXPERT_NAME', false)}
          </div> : ''}
        <div className={styles.actionBlock}>
          <div className={styles.actionRow}>
            <img alt="" className={styles.actionIcon} src={require('../../assets/images/web_dearchive_75x75.png')} />
            <img alt="" className={styles.actionIcon} src={require('../../assets/images/web_refusal_75x75.png')} />
          </div>
          <div className={styles.actionRow}>
            {this.props.roles.includes(Role.ApAs) ? <img alt="" className={styles.actionIcon} src={require('../../assets/images/approve_selected_55x55.png')} /> : ''}
            {this.props.roles.includes(Role.CrInIn) ? <img alt="" className={styles.actionIcon} src={require('../../assets/images/honorary_selected_55x55.png')} /> : ''}
            {this.props.roles.includes(Role.AsUs) ? <img alt="" className={styles.actionIcon} src={require('../../assets/images/assign_selected_55x55.png')} /> : ''}
          </div>
        </div>
        <div className={`${styles.text} ${styles.separator}`} onClick={() => this.setSortValues('INSURED_PERSON_NAME')}>
          <span></span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ caseState, shared }: ApplicationState) => ({
  roles: shared.roles,
  sortColumn: caseState.caseSearch.sortColumn,
  sortDirection: caseState.caseSearch.sortDirection,
  caseSearch: caseState.caseSearch
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchCases: (caseSearch: CaseSearch, offset: number, searchClicked: boolean) => dispatch(fetchCases(caseSearch, offset, searchClicked)),
  clearCases: () => dispatch(clearCases())
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseDetailsHeader);
